import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import {format} from 'date-fns';

const UsersCouponTable = ({usersCoupon}) => {
  const getStatus = {
    all: 'Todos',
    active: 'Ativos',
    inactive: 'Inativo',
    expired: 'Expirado',
    cancelled: 'Cancelado',
    pending: 'Pendente',
  };

  if (usersCoupon.length === 0) {
    return <h1>Carregando...</h1>;
  }

  return (
    <TableContainer component={Paper}>
      <Table sx={{minWidth: 650}} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Código do Cupom</TableCell>
            <TableCell align="center">Nome</TableCell>
            <TableCell align="center">Email</TableCell>
            <TableCell align="center">Data de resgate</TableCell>
            <TableCell align="center">Data de Expiração</TableCell>
            <TableCell align="center">Número de Parcelas Restantes</TableCell>
            <TableCell align="center">Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {usersCoupon.map((row, index) => {
            const startDate = format(
              new Date(row.createdAt.split('T')[0] + 'T12:00:00'),
              'dd/MM/yyyy',
            );
            const expirationDate = row.expirationDate
              ? format(
                  new Date(row.expirationDate.split('T')[0] + 'T12:00:00'),
                  'dd/MM/yyyy',
                )
              : '-';

            return (
              <TableRow
                key={index}
                sx={{'&:last-child td, &:last-child th': {border: 0}}}>
                <TableCell component="th" scope="row">
                  {row?.coupon?.couponCode || '-'}
                </TableCell>
                <TableCell align="center">{row?.user?.name}</TableCell>
                <TableCell align="center">{row?.user?.email}</TableCell>
                <TableCell align="center">{startDate}</TableCell>
                <TableCell align="center">{expirationDate}</TableCell>
                <TableCell align="center">
                  {row?.remainingRenewalNumber || '-'}
                </TableCell>
                <TableCell align="center">
                  {getStatus[row?.status] || '-'}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default UsersCouponTable;
